<template>
  <v-dialog
      v-model="state.modal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
  >
    <v-card class="grey lighten-4">
      <v-toolbar dark :color="$mainColor" max-height="64">
        <div class="d-inline-block mr-2">
          <v-btn icon dark @click="$emit('update:id', null)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-toolbar-title>Предосмотр</v-toolbar-title>
      </v-toolbar>
      <v-sheet
          :height="pageHeight"
          class="px-6 pt-6 overflow-auto text-center"
          color="grey lighten-4"
      >
        <progress-page v-if="state.loading"/>
        <div v-if="state.success">
          <div v-for="(preview, index) in state.data" :key="'previewPage'+index" class="pb-6">
            <v-sheet
                v-if="preview.includes('.jpg') || preview.includes('.png')"
                :width="isZoom ? zoomMaxView-200 : 600"
                rounded class="d-inline-block overflow-hidden transition-ease-in-out" elevation="2"
            >
              <v-img :src="preview" class="full-width"/>
            </v-sheet>
            <v-sheet
                v-else-if="preview.includes('.mp4')"
                :width="isZoom ? zoomMaxView : 800"
                rounded class="d-inline-block overflow-hidden" elevation="2"
            >
              <video :src="preview" controls class="full-width float-left"></video>
            </v-sheet>
            <v-sheet
                v-else-if="preview.includes('.mp3')"
                :width="isZoom ? zoomMaxView : 600"
                rounded class="d-inline-block overflow-hidden pa-4" elevation="2"
            >
              <audio :src="preview" controls class="full-width float-left"></audio>
            </v-sheet>
            <v-sheet
                v-else
                rounded class="d-inline-block overflow-hidden pa-4" elevation="2"
            >
              <div>
                <v-icon size="34" class="mb-2">mdi-information-outline</v-icon>
                <div class="body-2">Просмотр не доступен</div>
              </div>
            </v-sheet>
          </div>
          <div class="position-fixed" style="z-index: 1000; right: 2rem;bottom: 1rem">
            <v-btn fab dark color="primary" @click="isZoom = !isZoom">
              <v-icon dark>{{isZoom ? 'mdi-magnify-minus-outline' : 'mdi-magnify-plus-outline'}}</v-icon>
            </v-btn>
          </div>
        </div>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/Api";
import axios from "axios";
import Stater from "../../plugins/stater";
import pageHeight from "../../mixins/pageHeight";
import ProgressPage from "../../components/ProgressPage.vue";

export default {
  components: {ProgressPage},
  props: ['id'],
  mixins: [pageHeight],
  data: () => ({
    state: new Stater(),
    mediaData:null,
    isZoom: false,
    zoomMaxView: 0,
    previews:[],
  }),
  watch:{
    id(){
      if (this.id==null){
        this.state.modalClose();
      } else{
        this.state.modalOpen();
        this.state.stateLoading();
        axios.get(Api.host+'/medRecord/medRecord/'+this.id+'/preview/')
            .then(r => {
              this.state.data = r.data;
              this.state.stateSuccess();
            })
            .catch(() =>{
              this.state.stateError();
            });
      }
    }
  },
  mounted() {
    this.zoomMaxView = window.innerWidth-600 > 1200 ? 1200 : window.innerWidth-600
  },
}
</script>